var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<div class=\"p-l-3\"><div ng-repeat=\"tagKind in ::$ctrl.tagKinds\" class=\"clearfix\"><span class=\"pull-left\">{{::tagKind}}:</span><div class=\"pull-left p-l-1\"><div ng-repeat=\"val in $ctrl.tags[tagKind] \"><strong>{{::val}}</strong></div></div></div></div>";
var id1="tags-viewer.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;